// extracted by mini-css-extract-plugin
export var label = "_i7-2";
export var slideContainer = "_i7-0";
export var slider = "_i7-1";